import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ChipsService {
    private chips: Array<any>;
    public chips$ = new BehaviorSubject(undefined);
    setChips(chips) {
        this.chips = Object.assign([],chips);
        this.chips$.next(chips);
    }
    getChips() {
        return this.chips$;
    }
    addChip(label, link) {
        let chip = {
            "label": label,
            "routerLink": link
        }
        this.chips.push(chip);
        this.setChips(this.chips);
    }
}